
var protocol=location.protocol,
    baseurl = protocol=='http:'?process.env.VUE_APP_BASE_API:process.env.VUE_APP_BASES_API;
const HOST={
    pic:baseurl, //图片资源拼接地址
    file:baseurl
}
 
export default HOST;